import { Button, colors, IMInputText, IMTextArea } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FormContentStyled = styled.div`
  padding: 3rem 4rem 0;
  width: 100%;
`;

export const PrimaryEmailSectionStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 3rem;
  width: 100%;
`;

export const IMInputTextStyled = styled(IMInputText)`
  width: 30rem;
  flex: none;
`;

export const CcSectionWrapperStyled = styled.div`
  margin-top: 5rem;
`;

export const CcFieldsListStyled = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const CcFieldWrapperStyled = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 3rem;
  padding-bottom: 2rem;
  margin: 0;

  &:last-of-type {
    padding-bottom: 0;
  }
`;

export const ListTitleStyled = styled.p`
  font-size: 1.6rem;
  font-weight: 600;
  color: ${colors.neutral[900]};
  margin: 0;
  padding-bottom: 2rem;
  text-align: start;
`;

// padding-top: 2.2% ensures the button is roughly in the middle of the row with and without the "Required" block in the neighboring input.
export const ButtonStyled = styled(Button)`
  padding-top: 2.2%;
  font-weight: 700;
  text-transform: uppercase;
  min-width: 15rem;
`;

export const IMTextAreaStyled = styled(IMTextArea)`
  width: 100%;
  flex: none;
  margin-top: 3rem;
`;

export const ErrorStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.4rem;
  color: ${colors.red[600]};
  margin-top: 4rem;
`;
